<template>
  <div class="wrapper">
    <div class="waer">
      <div class="nav">首页 > 产品中心</div>
      <div class="wrap1">
        <div id="" class="head-label">
          <div style="text-align: center" class="font_size_24">产品中心</div>
          <div class="head-hen" style="text-align: center"></div>
          <div class="font_size_24_yin" style="text-align: center">
            RELATED PRODUCT INTRODUCTION
          </div>
        </div>
        <div class="container">
          <div class="item" v-for="(item, index) in product" :key="index">
            <div class="slide-img">
              <img :src="item.img" alt="" />
            </div>
            <div class="title">{{ item.tiele }}</div>
            <div class="describe">水浸探测器</div>
          </div>
        </div>
      </div>
      <div class="wrap2">
        <div class="recommend">
          <div class="xian"></div>
          <div class="char">为你推荐</div>
          <div class="xian"></div>
        </div>
        <div class="wrap3-border">
          <swiper
            :modules="modules"
            :slides-per-view="seen ? 5 : 1"
            :space-between="50"
            :loop="true"
            navigation
            :pagination="{ clickable: true }"
            :autoplay="{
              delay: 90000,
              pauseOnMouseEnter: true,
              disableOnInteraction: false,
            }"
            @swiper="onSwiper"
            @slideChange="onSlideChange"
          >
            <swiper-slide v-for="(item, index) in product" :key="index"
              ><div class="border-slide">
                <div class="border-slide-img">
                  <img :src="item.img" alt="" />
                </div>
                <div class="border-slide-bom">
                  <div class="titer">{{ item.tiele }}</div>
                  <div class="number">{{ item.number }}</div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation, A11y, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const feature = ref();

    return {
      feature,
    };
  },
  data() {
    return {
      modules: [Navigation, A11y, Autoplay],
      seen: true,
      product: [
        {
          tiele: "水浸探测器",
          img: require("../../../static/other/product-6.png"),
          // number: "WANLIN-312",
          notes: "WANLIN-312",
        },
        {
          tiele: "独立式光电感烟火灾探测报警器",
          img: require("../../../static/other/product-2.png"),
          // number: "WANLIN-308",
          notes: "WANLIN-308",
        },
        {
          tiele: "燃气探测器",
          img: require("../../../static/other/product-3.png"),
          // number: "WANLIN-309",
          notes: "WANLIN-309",
        },
        {
          tiele: "SOS紧急呼叫按钮",
          img: require("../../../static/other/product-1.png"),
          // number: "WANLIN-307",
          notes: "WANLIN-307",
        },
        {
          tiele: "门磁",
          img: require("../../../static/other/product-4.png"),
          // number: "WANLIN-310",
          notes: "WANLIN-310",
        },
        {
          tiele: "门铃",
          img: require("../../../static/other/product-5.png"),
          // number: "WANLIN-311",
          notes: "WANLIN-311",
        },
        {
          tiele: "水浸探测器",
          img: require("../../../static/other/product-6.png"),
          // number: "WANLIN-312",
          notes: "WANLIN-312",
        },
        {
          tiele: "水浸探测器",
          img: require("../../../static/other/product-6.png"),
          // number: "WANLIN-312",
          notes: "WANLIN-312",
        },
      ],
    };
  },
  created() {},
  mounted() {
    this.menuSeen();
  },
  methods: {
    onSwiper() {},
    onSlideChange() {},
    menuSeen() {
      // 屏幕尺寸
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 430) {
        this.seen = true;
      } else {
        this.seen = false;
      }
    },

  },
};
</script>
<style lang="scss" scoped >
@import "./ProductCenter.scss";
</style>

